import React from 'react';
import TrendsTitle from './TrendsTitle';
import { Col, Row } from 'react-bootstrap';
import TrendsTable from './TrendsTable';
import TrendsWideTable from './TrendsWideTable';

const TrendsContentItem = ({ item }) => {
  if (item.type === "paragraph")
    return ( <Col className='mx-auto col-lg-10 col-xl-8 text-gray-600'><p dangerouslySetInnerHTML={{ __html: item.content }} /></Col>);

  if (item.type === "list")
    return (<Col className='mx-auto col-lg-10 col-xl-8 text-gray-600'><ul>{item.content.map((listItem, index) =>
      <li key={index} dangerouslySetInnerHTML={{ __html: listItem }} />)}</ul></Col>)

  if (item.type === 'blockquote')
    return <Col className='mx-auto col-lg-10 col-xl-8'>
        <blockquote
          className="blockquote p-4"
          dangerouslySetInnerHTML={{ __html: item.content }}
        />
    </Col>

  if (item.type === "title")
    return <Col className='mx-auto col-lg-10 col-xl-8 text-content'><TrendsTitle title={item.content.title} titleLevel={item.content.titleLevel} /></Col>

  if (item.type === "table")
    return <Col className='mx-auto col-lg-10 col-xl-8'><TrendsTable content={item.content} /></Col>

  if (item.type === "wide-table")
    return <Col className='mx-auto mb-4 col-xl-9'><TrendsWideTable content={item.content} /></Col>
}

const TrendsContent = ({ content }) => {
  return (
    content.map((item, index) => {
      return <TrendsContentItem item={item} key={index}/>
    }));
}

export default TrendsContent;
